import * as React from 'react';
import Colors from '../../constants/Colors';
import styled from 'styled-components';

import NavBar from '../Site/NavBar';

const StyledBar = styled.div`
  display: grid;
  color: #fff;
  align-content: center;
  background: ${Colors.darkSteel};
  grid-auto-flow: column;
`;

const StyledButton = styled.button`
  color: #fff;
  background: ${Colors.deepBlueGray};
`;

type Props = {
  theme: string;
  updateTheme: () => void;
};

const BotBar: React.SFC<Props> = ({ theme, updateTheme }) => (
  <StyledBar>
    <div>theme: {theme}</div>
    <StyledButton onClick={updateTheme} value="dark">
      Dark
    </StyledButton>
    <StyledButton onClick={updateTheme} value="light">
      Light
    </StyledButton>
    <StyledButton onClick={updateTheme} value="dracula">
      Dracula
    </StyledButton>
    <StyledButton onClick={updateTheme} value="bright">
      Bright
    </StyledButton>
    <NavBar />
  </StyledBar>
);

export default BotBar;



// WEBPACK FOOTER //
// ./src/containers/Site/BotBar.tsx